import { Paragraph } from 'src/components/atoms/Typography'
import { TypographyRebrand } from 'src/components/atoms/TypographyRebrand'

import { FormFieldTypes } from 'src/types/form'
import { PaymentMethod } from 'src/types/purchase'

import { FormField } from '../FormField'

type PaymentContactDetailsProps = {
  handleReceiptNameBlur: (e: React.ChangeEvent<HTMLInputElement>) => void
  ReceiptNameField?: string
  ReceiptEmailField?: string
  isRecurring?: boolean
  paymentMethod: string
}

export const PaymentContactDetails = ({
  handleReceiptNameBlur,
  ReceiptEmailField = 'ReceiptEmail',
  ReceiptNameField = 'ReceiptName',
  isRecurring = false,
  paymentMethod
}: PaymentContactDetailsProps) => {
  const paymentDescription =
    paymentMethod === PaymentMethod.Invoice ? 'an invoice' : 'a receipt'
  const paymentInput =
    paymentMethod === PaymentMethod.Invoice ? 'invoice' : 'receipt'
  return (
    <div className='mb-8'>
      <div className='mb-[10px]'>
        <TypographyRebrand variant='h4' color='forestDeep'>
          Receipt details
        </TypographyRebrand>
      </div>
      <Paragraph className='mb-0! font-medium text-forestDeep!'>
        {isRecurring
          ? 'Enter the name and email address for your monthly donation receipt.'
          : `Who should we send ${paymentDescription} to?`}
      </Paragraph>
      <div className='max-w-sm'>
        <FormField
          className='mt-5!'
          id={ReceiptNameField}
          label={`Name on the ${paymentInput}`}
          labelClassName='text-forestDeep!'
          type={FormFieldTypes.text}
          onBlur={handleReceiptNameBlur}
        />
        <FormField
          id={ReceiptEmailField}
          label='Email the receipt to'
          labelClassName='text-forestDeep!'
          type={FormFieldTypes.text}
        />
      </div>
      <Paragraph className='text-[14px]! font-medium border-l-[5px] border-lavenderSoft p-[10px]! text-forestDeep!'>
        Don&apos;t forget to claim your tax credit. As a registered charitable
        trust, your transactions are donations that are tax deductible. You can
        log back in to download your tax certificates.
      </Paragraph>
    </div>
  )
}
